import Phaser from 'phaser';
import SoundManager from '../audio/SoundManager';
import { getGameContext, setGameContext } from './context';
import type { GameContext } from '../types/GameContext';

/**
 * Ensure a GameContext exists for the given scene and that a SoundManager
 * is available and initialized with this scene. Safe to call multiple times.
 */
export function initSceneContext(scene: Phaser.Scene): GameContext {
  // Get or create a base context object
  let ctx: Partial<GameContext>;
  try {
    ctx = getGameContext(scene) as Partial<GameContext>;
  } catch {
    ctx = {};
  }

  // Ensure a SoundManager is present and initialized for this scene
  if (!ctx.sound) {
    const soundManager = new SoundManager();
    soundManager.initFromScene(scene);
    // cast any to avoid widening GameContext in this module
    (ctx as any).sound = soundManager;
  } else {
    // If the SoundManager exists but might be bound to a different scene, re-init defensively
    // This is safe and idempotent for our SoundManager implementation.
    try {
      (ctx.sound as any).initFromScene?.(scene);
    } catch {
      // ignore
    }
  }

  // Publish merged context for this scene scope
  setGameContext(scene, ctx as GameContext);

  return ctx as GameContext;
}